/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CompanyPermissionsCodename {
    CREATE_NEXT_PATIENT = 'create_next_patient',
    SEND_SMS = 'send_sms',
    ONLINE_RESERVATIONS = 'online_reservations',
    GOOGLE_CALENDAR_SYNC = 'google_calendar_sync',
    CREATE_NEXT_PHYSIOTHERAPIST = 'create_next_physiotherapist',
    CREATE_NEXT_ROOM = 'create_next_room',
    ALLOW_INSURANCE_COMPANIES = 'allow_insurance_companies',
    ALLOW_WAREHOUSE = 'allow_warehouse',
    ALLOW_M_RECORDS = 'allow_m_records',
    ALLOW_AI_FEATURES = 'allow_ai_features',
    ALLOW_CALENDAR = 'allow_calendar',
    ALLOW_PAYMENTS = 'allow_payments',
    ALLOW_STATISTICS = 'allow_statistics',
    ALLOW_OFFICE = 'allow_office',
    ALLOW_SUBSCRIPTION_CARD_PAYMENT = 'allow_subscription_card_payment',
    HIDE_NEXT_ORDER_PRICE_SUMMARY = 'hide_next_order_price_summary',
}
